import * as z from "zod";

export const updateAmazonIntegration = {
  name: "updateAmazonIntegration" as const,
  input: z
    .object({
      ordersSyncEnabled: z.boolean().optional(),
      buyShippingEnabled: z.boolean().optional(),
      disconnect: z.boolean().optional(),
    })
    .refine(
      ({ disconnect, ordersSyncEnabled, buyShippingEnabled }) =>
        disconnect !== true ||
        (ordersSyncEnabled === undefined && buyShippingEnabled === undefined),
      "Disconnect cannot be combined with product toggle updates",
    ),
  output: z.object({ rateRefreshStarted: z.boolean().optional() }),
};
